import { theme } from "twin.macro";

export type { Breakpoint } from "./BreakPoints";

export type Space = "none" | "xs" | "sm" | "md" | "lg" | "xl";

export const SPACE: Record<Space, string> = {
  none: "0",
  xs: theme("spacing.1"),
  sm: theme("spacing.2"),
  md: theme("spacing.4"),
  lg: theme("spacing.6"),
  xl: theme("spacing.10"),
};

export type Align = "start" | "center" | "end" | "stretch";

export const FLEX_ALIGN: Record<Align, string> = {
  start: "flex-start",
  center: "center",
  end: "flex-end",
  stretch: "stretch",
};
